namespace TabAurous.Finance {
    export interface ServiceOutwardRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        NetAmount?: number;
        GrossAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxId?: number;
        Rate?: number;
        TaxAmount?: number;
        TdsTotal?: number;
        TaxLedgerId?: number;
        KnockOffTotal?: number;
        Details?: ServiceOutwardDetailsRow[];
        TaxDetails?: ServiceOutwardTaxRow[];
        Pincode?: string;
        GstVat?: string;
        Pan?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ServiceOutwardRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.ServiceOutward';
        export const deletePermission = 'Finance:ServiceOutward:Delete';
        export const insertPermission = 'Finance:ServiceOutward:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:ServiceOutward:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            NetAmount = "NetAmount",
            GrossAmount = "GrossAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxId = "TaxId",
            Rate = "Rate",
            TaxAmount = "TaxAmount",
            TdsTotal = "TdsTotal",
            TaxLedgerId = "TaxLedgerId",
            KnockOffTotal = "KnockOffTotal",
            Details = "Details",
            TaxDetails = "TaxDetails",
            Pincode = "Pincode",
            GstVat = "GstVat",
            Pan = "Pan",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
